import { render, staticRenderFns } from "./read-record.vue?vue&type=template&id=687a746e&scoped=true"
import script from "./read-record.vue?vue&type=script&lang=js"
export * from "./read-record.vue?vue&type=script&lang=js"
import style0 from "./read-record.vue?vue&type=style&index=0&id=687a746e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a746e",
  null
  
)

export default component.exports